/**
 * Get auth token from localStorage
 */
export const getAuthToken = () => {
    const currentUser = localStorage.getItem("loggedinUser");
    return currentUser ? JSON.parse(currentUser).token : null;
};

/**
 * Set auth token and user data in localStorage
 */
export const setAuthToken = (token) => {
    const currentUser = JSON.parse(localStorage.getItem("loggedinUser") || "{}");
    currentUser.token = token;
    localStorage.setItem("loggedinUser", JSON.stringify(currentUser));
};

/**
 * Set user data in localStorage
 */
export const setUserData = (userData) => {
    const currentUser = JSON.parse(localStorage.getItem("loggedinUser") || "{}");
    const updatedUser = { ...currentUser, ...userData };
    localStorage.setItem("loggedinUser", JSON.stringify(updatedUser));
};

/**
 * Get user data from localStorage
 */
export const getUserData = () => {
    const currentUser = localStorage.getItem("loggedinUser");
    return currentUser ? JSON.parse(currentUser) : null;
};

/**
 * Clear all auth data
 */
export const clearAuthData = () => {
    localStorage.removeItem("loggedinUser");
    sessionStorage.clear();
};
